/**
 * Ontwerpen in de winkelmand: groot bekijken, opnieuw openen en dupliceren.
 *
 * Alles loopt via klikken op het document en niet via losse koppelingen per
 * knop. De winkelmand wordt na elke wijziging opnieuw opgebouwd door het thema
 * (lade en pagina allebei); een koppeling op een knop zou dan verdwijnen.
 *
 * De knoppen "Ontwerp aanpassen" en "Dupliceren" staan standaard verborgen en
 * verschijnen pas als het ontwerp in deze browser bewaard is. Zonder bewaard
 * ontwerp kunnen ze toch niets doen, en een knop die niets doet is erger dan
 * geen knop.
 */
(() => {
  if (window.__flagcfgWinkelmand) return;
  window.__flagcfgWinkelmand = true;

  const wortel = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Wacht tot de opslagmodule er is. Hier staat die direct boven dit script en
  // is hij er dus meestal al, maar net als in de ontwerptool geven we niet op
  // voordat hij echt geladen is (of na ruime tijd niet komt).
  const opslag = () =>
    new Promise((klaar) => {
      if (window.FlagOntwerpOpslag) return klaar(window.FlagOntwerpOpslag);
      let gemeld = false;
      const meld = (waarde) => {
        if (gemeld) return;
        gemeld = true;
        clearInterval(peiling);
        clearTimeout(opgeven);
        document.removeEventListener('flagcfg:opslag-klaar', bijSeintje);
        klaar(waarde);
      };
      const bijSeintje = () => meld(window.FlagOntwerpOpslag || null);
      document.addEventListener('flagcfg:opslag-klaar', bijSeintje);
      const peiling = setInterval(() => {
        if (window.FlagOntwerpOpslag) meld(window.FlagOntwerpOpslag);
      }, 50);
      const opgeven = setTimeout(() => meld(window.FlagOntwerpOpslag || null), 10000);
    });

  const haalWinkelmand = () =>
    fetch(wortel() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) =>
      r.json()
    );

  // ---------- knoppen tonen die een bewaard ontwerp nodig hebben ----------

  let wachttijd = null;
  const controleerKnoppen = () => {
    clearTimeout(wachttijd);
    wachttijd = setTimeout(async () => {
      const rijen = document.querySelectorAll('[data-flagcfg-regel]');
      if (!rijen.length) return;
      const o = await opslag();
      rijen.forEach(async (rij) => {
        const id = rij.getAttribute('data-ontwerp-id');
        const bewaard = !!(id && o && (await o.bestaat(id)));
        rij.querySelectorAll('[data-flagcfg-bewaard]').forEach((knop) => {
          if (knop.hidden === !bewaard) return;
          knop.hidden = !bewaard;
        });
      });
    }, 80);
  };

  // ---------- groot bekijken ----------

  const bekijk = async (knop) => {
    const rij = knop.closest('[data-flagcfg-regel]');
    if (!rij) return;
    const id = rij.getAttribute('data-ontwerp-id');
    const o = await opslag();
    const ontwerp = id && o ? await o.haal(id) : null;

    const losTeLaten = [];
    let beelden = [];
    if (ontwerp && Array.isArray(ontwerp.zijden)) {
      const dubbel = ontwerp.zijden.length > 1;
      beelden = ontwerp.zijden
        .filter((z) => z && z.voorbeeld)
        .map((z) => {
          const url = URL.createObjectURL(z.voorbeeld);
          losTeLaten.push(url);
          return { label: dubbel ? z.label || '' : '', url };
        });
    }
    // Geen bewaard ontwerp (andere browser, of van voor deze functie): het
    // controlebeeld dat bij de bestelling hoort. Bij een dubbelzijdige vlag
    // staan daar beide kanten al op.
    if (!beelden.length && rij.dataset.controlebeeld) beelden = [{ label: '', url: rij.dataset.controlebeeld }];
    if (!beelden.length) return;

    const naastElkaar = beelden.length > 1 && window.innerWidth > window.innerHeight;

    // Een eigen <dialog>. De winkelmand-lade is zelf een dialoog in de
    // bovenste laag van het scherm; een gewoon element met een hoge z-index
    // zou daaronder verdwijnen.
    const venster = document.createElement('dialog');
    venster.setAttribute('data-flagcfg-winkelmandvoorbeeld', '');
    venster.setAttribute('aria-label', rij.dataset.tTitel || 'Ontwerp');
    venster.style.cssText = [
      'position:fixed', 'inset:0', 'width:100vw', 'height:100vh', 'max-width:100vw', 'max-height:100vh',
      'margin:0', 'padding:56px 16px 24px', 'border:0', 'box-sizing:border-box',
      'background:rgb(18 19 21 / .94)', 'color:#fff', 'overflow:auto',
    ].join(';');

    const rijBeelden = document.createElement('div');
    rijBeelden.style.cssText = [
      'min-height:100%', 'display:flex', 'gap:18px', 'align-items:center', 'justify-content:center',
      'flex-direction:' + (naastElkaar ? 'row' : 'column'),
    ].join(';');

    beelden.forEach((b) => {
      const vak = document.createElement('figure');
      vak.style.cssText =
        'margin:0;display:flex;flex-direction:column;align-items:center;gap:7px;min-width:0;max-width:' +
        (naastElkaar ? 'calc(50% - 9px)' : '100%');
      if (b.label) {
        const t = document.createElement('figcaption');
        t.textContent = b.label;
        t.style.cssText =
          'order:-1;color:rgb(255 255 255 / .72);font:600 11px/1 system-ui,sans-serif;letter-spacing:.09em;text-transform:uppercase';
        vak.appendChild(t);
      }
      const img = document.createElement('img');
      img.src = b.url;
      img.alt = b.label || rij.dataset.tTitel || '';
      img.decoding = 'async';
      const hoogte = beelden.length > 1 && !naastElkaar ? '36vh' : '76vh';
      img.style.cssText =
        'display:block;max-width:100%;max-height:' + hoogte +
        ';width:auto;height:auto;border-radius:3px;background:#fff;box-shadow:0 8px 30px rgb(0 0 0 / .5)';
      vak.appendChild(img);
      rijBeelden.appendChild(vak);
    });

    const sluit = document.createElement('button');
    sluit.type = 'button';
    sluit.textContent = rij.dataset.tSluit || 'Sluiten';
    sluit.style.cssText = [
      'position:fixed', 'top:12px', 'right:12px', 'min-height:44px', 'padding:10px 22px', 'border:none',
      'border-radius:999px', 'font:600 15px/1 system-ui, sans-serif', 'cursor:pointer', 'background:#fff',
      'color:#1c1c1c', 'box-shadow:0 2px 10px rgb(0 0 0 / .3)',
    ].join(';');
    // Opruimen gebeurt meteen bij het sluiten, niet pas als het signaal
    // "close" van de browser binnenkomt: dat bleef in de test uit, en dan bleef
    // er bij elke keer bekijken een onzichtbaar venster in de pagina achter.
    let opgeruimd = false;
    const weg = () => {
      if (opgeruimd) return;
      opgeruimd = true;
      if (venster.open) {
        try {
          venster.close();
        } catch (err) {
          /* al dicht */
        }
      }
      losTeLaten.forEach((u) => URL.revokeObjectURL(u));
      venster.remove();
    };
    sluit.addEventListener('click', weg);

    venster.append(rijBeelden, sluit);
    venster.addEventListener('click', (e) => {
      if (e.target === venster || e.target === rijBeelden) weg();
    });
    // Escape: de browser sluit het venster zelf, daarna opruimen.
    venster.addEventListener('cancel', () => setTimeout(weg, 0));
    venster.addEventListener('close', weg);

    document.body.appendChild(venster);
    if (typeof venster.showModal === 'function') venster.showModal();
    else venster.setAttribute('open', '');
    sluit.focus();
  };

  // ---------- dupliceren ----------

  const meld = (rij, tekst) => {
    const plek = rij.querySelector('[data-flagcfg-melding]');
    if (!plek) return;
    plek.textContent = tekst;
    plek.hidden = !tekst;
    if (tekst) setTimeout(() => { plek.hidden = true; }, 5000);
  };

  const dupliceer = async (knop) => {
    const rij = knop.closest('[data-flagcfg-regel]');
    if (!rij || knop.getAttribute('aria-busy') === 'true') return;
    const sleutel = rij.getAttribute('data-key');
    const id = rij.getAttribute('data-ontwerp-id');
    if (!sleutel || !id) return;

    knop.setAttribute('aria-busy', 'true');
    knop.disabled = true;
    try {
      const winkelmand = await haalWinkelmand();
      const regel = winkelmand.items.find((i) => i.key === sleutel);
      if (!regel) throw new Error('regel niet meer in de winkelmand');

      // Een nieuwe sleutel is nodig: met precies dezelfde eigenschappen voegt
      // Shopify hem samen met de bestaande regel, en dan heb je geen kopie
      // maar alleen een hoger aantal.
      const basis = id.split('-k')[0];
      const nieuwId = basis + '-k' + Date.now().toString(36).slice(-4) + Math.random().toString(36).slice(2, 6);

      const o = await opslag();
      if (o) await o.kopieer(id, nieuwId);

      const eigenschappen = Object.assign({}, regel.properties || {}, { '_Ontwerp-id': nieuwId });
      const antwoord = await fetch(wortel() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: regel.variant_id, quantity: 1, properties: eigenschappen }] }),
      });
      if (!antwoord.ok) throw new Error('toevoegen mislukt');

      const nieuw = await haalWinkelmand();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: nieuw,
            sourceId: 'flagcfg-winkelmand',
            data: { source: 'flagcfg-winkelmand', itemCount: nieuw.item_count },
          },
        })
      );
    } catch (fout) {
      meld(rij, rij.dataset.tMislukt || 'Dat lukte niet. Probeer het opnieuw.');
    } finally {
      knop.removeAttribute('aria-busy');
      knop.disabled = false;
    }
  };

  // ---------- koppelen ----------

  document.addEventListener('click', (e) => {
    const doel = e.target instanceof Element ? e.target : null;
    if (!doel) return;
    const bekijkKnop = doel.closest('[data-flagcfg-bekijk]');
    if (bekijkKnop) {
      e.preventDefault();
      bekijk(bekijkKnop);
      return;
    }
    const dupliceerKnop = doel.closest('[data-flagcfg-dupliceer]');
    if (dupliceerKnop) {
      e.preventDefault();
      dupliceer(dupliceerKnop);
    }
  });

  document.addEventListener('cart:update', () => {
    // Het thema bouwt de regels na dit signaal opnieuw op; even wachten.
    setTimeout(controleerKnoppen, 350);
    setTimeout(controleerKnoppen, 1200);
  });

  const waarnemer = new MutationObserver((mutaties) => {
    if (mutaties.some((m) => m.addedNodes.length)) controleerKnoppen();
  });
  const start = () => {
    controleerKnoppen();
    waarnemer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
